import styled from '@emotion/styled';
import { Stack } from '@mui/material';

import { hoverable } from '@/shared/design-system';

export const MethodCard = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  gap: '12px',
  padding: theme.spacing[12],
  margin: `0 -${theme.spacing[12]}px`,
  borderRadius: theme.radius[8],
  cursor: 'pointer',
  flex: 1,
  ...hoverable(theme, 'surface'),
}));

export const DisabledMethodCard = styled(MethodCard)({
  cursor: 'not-allowed',
  opacity: 0.5,
});

export const MethodIconBox = styled('div')(({ theme }) => ({
  width: 52,
  height: 52,
  borderRadius: 8,
  backgroundColor: theme.colors.white[8],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  '& svg': {
    width: 24,
    height: 24,
    color: theme.colors.white[100],
  },
}));

export const MethodTextBlock = styled(Stack)({
  flexDirection: 'column',
  gap: '6px',
  flex: 1,
});
